import { useEffect } from 'react';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { useDispatch } from 'react-redux';

import {
  Modal,
  ModalBody,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalFooter,
} from '@grupoboticario/flora-react';

import { clearAllSteps } from 'store/modules/openClaim/actions';
import { ModalText, ButtonFooter } from './styles';
import { ButtonSpaceG } from '../../sharedStyles';

interface IModalSaveDraft {
  stateModal: {
    display: number;
    errorMessage: string;
  };
  setStateModal: any;
  setIsOpen: any;
  isOpen: boolean;
  handleSubmit?: any;
}

export const ModalSaveDraft = (props: IModalSaveDraft): JSX.Element => {
  const { setIsOpen, isOpen, handleSubmit, stateModal, setStateModal } = props;

  const history = useHistoryWithHost();
  const dispatch = useDispatch();

  const navigateToHome = () => {
    setIsOpen(false);
    dispatch(clearAllSteps());
    history.push('/');
  };

  const trySaveDraft = () => {
    handleSubmit();
  };

  const closeModal = () => {
    setStateModal({ ...stateModal, display: 1 });
    setIsOpen(false);
  };

  useEffect(() => {}, [stateModal]);

  return (
    <Modal open={isOpen} onOpenChange={closeModal}>
      <ModalContent size="small">
        <ModalCloseButton />
        <ModalHeader />
        {stateModal.display === 1 && (
          <>
            <ModalBody>
              <ModalText>
                Se você sair desta página sem antes salvar um rascunho as
                informações serão perdidas,{' '}
                <span> deseja salvar um rascunho?</span>
              </ModalText>
            </ModalBody>
            <ButtonFooter>
              <ButtonSpaceG
                size="small"
                styleSemantic="success"
                onClick={() => trySaveDraft()}
              >
                Sim
              </ButtonSpaceG>
              <ButtonSpaceG size="small" onClick={() => navigateToHome()}>
                Não
              </ButtonSpaceG>
            </ButtonFooter>
          </>
        )}
        {stateModal.display === 2 && (
          <>
            <ModalBody>
              <ModalText>
                <span>Rascunho salvo!</span>
              </ModalText>
            </ModalBody>
            <ButtonFooter>
              <ButtonSpaceG
                size="small"
                styleSemantic="conversion"
                onClick={() => navigateToHome()}
              >
                Ok
              </ButtonSpaceG>
            </ButtonFooter>
          </>
        )}
        {stateModal.display === 3 && (
          <>
            <ModalBody>
              <ModalText>
                <span>Falha ao salvar o rascunho:</span>
                <br />
                {stateModal.errorMessage}
              </ModalText>
            </ModalBody>
            <ButtonFooter>
              <ButtonSpaceG
                size="small"
                styleSemantic="conversion"
                onClick={() => closeModal()}
              >
                Ok
              </ButtonSpaceG>
            </ButtonFooter>
          </>
        )}

        <ModalFooter />
      </ModalContent>
    </Modal>
  );
};
